import {
  ClientDetailedDto,
  ExternalSystem,
  ExternalSystemId,
} from 'api/Clients/Types/ClientDetailedDto'
import { TickmillCompanyTypes } from 'api/Clients/Types/TickmillCompanyTypes'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'

const isTickmillCompanyUK = (companyId?: number) =>
  companyId === TickmillCompanyTypes.Tickmill_UK_Company

const hasIBKRInExternalSystems = (externalSystems: ExternalSystem[] | undefined): boolean => {
  if (!externalSystems || externalSystems.length === 0) return false
  return externalSystems.some((system) => system.externalSystem.id === ExternalSystemId.IBKR)
}

const isIbkrVisibleForClient = (client: ClientDetailedDto): boolean => {
  return (
    hasIBKRInExternalSystems(client.externalSystems) &&
    isTickmillCompanyUK(client.tickmillCompany?.id)
  )
}

const isIbkrVisibleForLead = (lead: LeadDetailsDto): boolean => {
  return (
    hasIBKRInExternalSystems(lead.externalSystems) && isTickmillCompanyUK(lead.tickmillCompany?.id)
  )
}

const filterIbkr = (systems: ExternalSystem[], isVisible: boolean): ExternalSystem[] =>
  isVisible ? systems : systems.filter((s) => s.externalSystem.id !== ExternalSystemId.IBKR)

export const getClientExternalSystems = (client: ClientDetailedDto): ExternalSystem[] => {
  const systems = client.externalSystems ?? []
  if (systems.length === 0) return systems
  return filterIbkr(systems, isIbkrVisibleForClient(client))
}

export const getLeadExternalSystems = (lead: LeadDetailsDto): ExternalSystem[] => {
  const systems = lead.externalSystems ?? []
  if (systems.length === 0) return systems
  return filterIbkr(systems, isIbkrVisibleForLead(lead))
}
